import React from 'react';
import {injectIntl} from "react-intl";
import SAInputComponent from "../../../common/input/SAInputComponent";
import UploadPictures from "../../../common/upload/UploadPictures";
import SAInputLabel from "../../../common/input/SAInputLabel";
import CategorySelector from "../../../common/select/CategorySelector";
import GearboxSelector from "../../../common/select/GearboxSelector";
import SADatePicker from "../../../common/input/SADatePicker";
import SAInputDistance from "../../../common/input/SAInputDistance";
import SAInputPercentageLabel from "../../../common/input/SAInputPercentageLabel";
import SATextAreaLabel from "../../../common/input/SATextAreaLabel";
import {AutoComplete, Divider} from "antd";
import Constants from "../../../../services/Constants";
import moment from 'moment';
import connect from "react-redux/es/connect/connect";
import SAInputNumberLabel from "../../../common/input/SAInputNumberLabel";
import FuelTypeSelector from "../../../common/select/FuelTypeSelector";
import SAInputCurrency from "../../../common/input/SAInputCurrency";
import Rental from "../../../../services/Rental";

const MAX_VEHICLE_PICTURE = 1;
const MAX_DAMAGE_ATTACHMENTS = 10;

const Option = AutoComplete.Option;

class RentalCar extends React.Component {

  constructor(props) {
    super(props);
    const vehicle = props.vehicle || this.defaultVehicle();
    this.state = {
      vehicle,
      fileList: {}
    };
  }

  defaultVehicle = () => {
    return {
      category: Constants.CATEGORY1.value,
      lastReport: {}
    }
  };

  handleChangeValue = (name, value) => {
    const {vehicle} = this.state;
    vehicle[name]=value;
    this.setState({vehicle});
  };

  handleChangeEvent = (event) => {
    const target = event.target;
    const value = (target.type === 'checkbox') ? target.checked : target.value;
    const name = target.name;
    this.handleChangeValue(name, value);
  };

  handleBeforeUpload = (file, category) => {
    this.setState((prevstate) => {
      const {fileList} = prevstate;
      fileList[category] = [...fileList[category] || [] , file]; // add the file to the category
      return {
        fileList,
        [category]: [...fileList, file], // probably not necessary
      }
    });
    return false;
  };

  handleFileRemove = (file, category) => {
    if (file.originFileObj) {
      // it means the file has not been uploaded yet
      const {fileList} = this.state;
      fileList[category] = fileList[category].filter(f => f.uid !== file.uid);
      this.setState({fileList});
      return;
    }
    this.setState(({outdatedFiles})=>({outdatedFiles:[...outdatedFiles||[], file.uid]}));
  };

  onIvsLookup = (vin) => {
    const formattedValue = vin.replace(/[^0-9A-Za-z]/g, '');
    this.handleChangeValue('vin', formattedValue);
    this.props.dispatchLookupIvsVinLookup(formattedValue);
  };

  handleIvsResultSelect = (vin)=>{
    const {vehicle} = this.state;
    const {ivsResults} = this.props;
    const ivsResult = ivsResults.get((vin));
    vehicle.vin = vin;
    vehicle.brand = ivsResult.brand;
    vehicle.model = ivsResult.model;
    vehicle.modelCode = ivsResult.modelCode;
    vehicle.color = ivsResult.color;
    this.setState({vehicle});
  };

  onSave = () => {
    const {vehicle, outdatedFiles, fileList} = this.state;
    this.props.onSave({vehicle, outdatedFiles, fileList});
  };

  render() {
    const {intl:{formatMessage}, errors, ivsResults } = this.props;
    const {vehicle} = this.state;
    const canWrite = !vehicle.vehicleId;
    const isVinVehicle = Rental.isVinVehicle(vehicle);

    const options = [];
    ivsResults.forEach((ivsResult, vin)=>options.push(<Option key={ivsResult.vin} value={vin}>{`${ivsResult.vin} ${ivsResult.brand} ${ivsResult.model} ${ivsResult.modelCode} ${ivsResult.color}`}</Option>))

    return (
      <section >
        <div className="modal__body">
          <h3 className="box__subtitle">{formatMessage({id: 'car-information.main.title'})}</h3>

          <div className="row">
            <ul className="list col-md-6 col-xxl-6">
              <li>
                <SAInputComponent name="category" label={formatMessage({id: 'vehicle.category'})}>
                  <CategorySelector name="category" value={vehicle.category} onChange={value => this.handleChangeValue('category', value)} disabled={!canWrite}/>
                </SAInputComponent>
              </li>
              <li>
                {isVinVehicle && canWrite &&
                  <AutoComplete onSearch={this.onIvsLookup}
                                dropdownMatchSelectWidth={false}
                                onSelect={this.handleIvsResultSelect}
                                dropdownStyle={{width: 700}}
                                optionLabelProp={"value"}
                                dataSource={options}>
                    <SAInputLabel name="vin" disabled={!canWrite} className={"uppercase"} value={vehicle.vin} label={'vehicle.vin'} error={errors.vin} maxLength={17}/>
                  </AutoComplete>
                }
                {isVinVehicle && !canWrite &&
                  <SAInputLabel name="vin" disabled={true} className={"uppercase"} value={vehicle.vin} label={'vehicle.vin'} error={errors.vin} maxLength={17}/>
                }
                {!isVinVehicle &&
                  <SAInputLabel name="vin" disabled={!canWrite} className={"uppercase"} onChange={this.handleChangeEvent} value={vehicle.vin} label={'vehicle.serialNumber'} error={errors.vin} maxLength={17}/>
                }
              </li>
              <li>
                <SAInputComponent label={formatMessage({id: 'vehicle.picture'})} error={errors.pictures}>
                  <UploadPictures files={vehicle.picture} showUploadList={{showPreviewIcon: false}}
                                  beforeUpload={(file) => this.handleBeforeUpload(file, 'picture')}
                                  onRemove={file => this.handleFileRemove(file, 'picture')}
                                  onChange={({fileList}) => this.setState(({vehicle}) => {
                                    vehicle['picture'] = fileList;
                                    return {vehicle};
                                  })}
                                  allowUpload={!vehicle.picture || vehicle.picture.length < MAX_VEHICLE_PICTURE}/>
                </SAInputComponent>
              </li>
            </ul>
            <ul className="list col-md-6 col-xxl-6">
              <li>
                <SAInputLabel name="brand" disabled={!canWrite} onChange={this.handleChangeEvent} value={vehicle.brand} label={'vehicle.make'} maxLength={25} error={errors.brand}/>
              </li>
              <li>
                <SAInputLabel name="model" disabled={!canWrite} onChange={this.handleChangeEvent} value={vehicle.model} label={'vehicle.model'} maxLength={25} error={errors.model}/>
              </li>
              <li>
                <SAInputLabel name="modelCode" onChange={this.handleChangeEvent} value={vehicle.modelCode} label={'vehicle.modelCode'} maxLength={25}/>
              </li>
              <li>
                <SAInputLabel name="licensePlate" onChange={evt => {
                  evt.target.value = evt.target.value.replace(/[^a-z0-9]/gmi, '');
                  this.handleChangeEvent(evt)
                }} value={vehicle.licensePlate} label={'vehicle.plate'} className={"uppercase"} maxLength={25} error={errors.licensePlate}/>
              </li>
            </ul>
          </div>
          <Divider/>
          <h3 className="box__subtitle">{formatMessage({id: 'car-information.detailed.title'})}</h3>

          <div className="row">
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputComponent name="gearbox" label={formatMessage({id: 'vehicle.gearbox'})}>
                  <GearboxSelector name="gearbox" value={vehicle.gearbox} onChange={this.handleChangeEvent} error={errors.gearbox}/>
                </SAInputComponent>
              </div>
            }
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputComponent name="fuelType" label={formatMessage({id: 'vehicle.fuel-type'})}>
                  <FuelTypeSelector name="fuelType" value={vehicle.fuelType} onChange={this.handleChangeEvent} error={errors.fuelType}/>
                </SAInputComponent>
              </div>
            }
            <div className="col-md-6 col-xxl-6">
              <SAInputLabel name="color" onChange={this.handleChangeEvent} value={vehicle.color} label={'vehicle.color'} maxLength={25} error={errors.color}/>
            </div>
            <div className="col-md-6 col-xxl-6">
              <SAInputComponent name="registrationDate" label={formatMessage({id: 'vehicle.registration-date'})}>
                <SADatePicker name="registrationDate" toIsoString={true} onChange={value => this.handleChangeValue('registrationDate', value)} value={vehicle.registrationDate}/>
              </SAInputComponent>
            </div>
            <div className="col-md-6 col-xxl-6">
              <SAInputComponent name="deactivationDate" label={formatMessage({id: 'vehicle.deactivation-date'})}>
                <SADatePicker name="deactivationDate" toIsoString={true} onChange={value => this.handleChangeValue('deactivationDate', value)} value={vehicle.deactivationDate} disabledDate={current => current && current < moment().endOf('day')}/>
              </SAInputComponent>
            </div>
            <div className="col-md-6 col-xxl-6">
              <SAInputComponent name="currentMileage" label={formatMessage({id: 'vehicle.current-mileage'})}>
                <SAInputDistance name="currentMileage" onChange={value => this.handleChangeValue('mileage', value)} value={vehicle.mileage} error={errors.mileage}/>
              </SAInputComponent>
            </div>
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputPercentageLabel label={formatMessage({id: 'vehicle.current-fuel'})} value={vehicle.fuel} onChange={value => this.handleChangeValue('fuel', value)} error={errors.fuel}/>
              </div>
            }
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputNumberLabel name="co2" min={1} onChange={value => this.handleChangeValue('co2', value)} value={vehicle.co2} label={formatMessage({id: 'vehicle.co2'})} error={errors.co2}/>
              </div>
            }
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputComponent name="additionalKmRate" label={formatMessage({id: 'vehicle.additional-km-rate'})}>
                  <SAInputCurrency name="additionalKmRate" onChange={value => this.handleChangeValue('additionalKmRate', value)} value={vehicle.additionalKmRate} min={0} step={0.1} error={errors.additionalKmRate}/>
                </SAInputComponent>
              </div>
            }
            {isVinVehicle &&
              <div className="col-md-6 col-xxl-6">
                <SAInputComponent name="deductible" label={formatMessage({id: 'vehicle.deductible'})}>
                  <SAInputCurrency name="deductible" onChange={value => this.handleChangeValue('deductible', value)} value={vehicle.deductible} min={0} step={50} error={errors.deductible}/>
                </SAInputComponent>
              </div>
            }
            <div className="col-md-12 col-xxl-12">
              <SAInputLabel name="remark" onChange={this.handleChangeEvent} value={vehicle.remark} label={'vehicle.remark'} maxLength={50}/>
            </div>
          </div>

          <Divider/>
          <h3 className="box__subtitle">{formatMessage({id: 'car-information.damage.title'})}</h3>

          <div className="row">
            <ul className="list col-md-12 col-xxl-12">
              <li>
                <SATextAreaLabel label={formatMessage({id: 'vehicle.damage-description'})} onChange={this.handleChangeEvent} value={vehicle.advisorComment} name="advisorComment" autosize={true}/>
              </li>
              <li>
                <SAInputComponent name="category" label={formatMessage({id: 'vehicle.damage-pictures'})} error={errors.reports}>
                  <UploadPictures files={vehicle.attachments}
                                  showUploadList={{showPreviewIcon: false}}
                                  beforeUpload={file => this.handleBeforeUpload(file, 'attachments')}
                                  onRemove={file => this.handleFileRemove(file, 'attachments')}
                                  onChange={({fileList}) => this.setState(({vehicle}) => {
                                    vehicle['attachments'] = fileList;
                                    return {vehicle};
                                  })}
                                  allowUpload={!vehicle.attachments || vehicle.attachments.length < MAX_DAMAGE_ATTACHMENTS}/>
                </SAInputComponent>
              </li>
            </ul>
          </div>

        </div>
        <footer className="modal__footer">
          <button className="btn btn-primary" key="save" type="primary" onClick={this.onSave}>{formatMessage({id: 'action.save'})}</button>
        </footer>
      </section>
    )
  }
}

const mapStateToProps = state => ({
    ivsResults: state.ivsResults.items ? new Map(state.ivsResults.items.map(item=>[item.vin, item])) : new Map()
});

const mapDispatchToProps = dispatch => ({
  dispatchLookupIvsVinLookup: (vin) => dispatch({type: 'LOOKUP_IVS_VIN.REQUEST', vin}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(RentalCar));
